export type Locale = 'pt' | 'en' | 'es';

export const LOCALES: Locale[] = ['pt', 'en', 'es'];

export const LOCALE_NAMES: Record<Locale, string> = {
  pt: 'PT-BR',
  en: 'EN',
  es: 'ES',
};

export const LOCALE_FULL_NAMES: Record<Locale, string> = {
  pt: 'Português',
  en: 'English',
  es: 'Español',
};

/* eslint-disable max-len */
export const dictionary = {
  pt: {
    nav: {
      tagline: 'Casa de Negócios',
      howItWorks: 'Como funciona',
      product: 'O produto',
      calculator: 'Calculadora',
      howItStarts: 'Como começa',
      cta: 'Diagnóstico',
      langLabel: 'Idioma',
    },
    hero: {
      eyebrow: 'arquitetura de receita · em operação',
      headline1: 'Sua empresa cresceu.',
      headline2: 'Sua operação não.',
      headline3: 'E é o seu lucro',
      headline4: 'que está em risco agora.',
      subheadPart1: 'Você fatura',
      subheadAmount: 'R$ 1 milhão a R$ 15 milhões',
      subheadPart2: ' e cada novo cliente, contratação ou ferramenta deixa o lucro ',
      subheadBrand1: 'MENOR',
      subheadPart3: ', não maior. Não é o mercado. É a operação. Em 6 meses, a ',
      subheadBrand2: 'Thux',
      subheadPart4: ' organiza o caminho até a ',
      subheadBrand3: 'venda virar lucro recorrente',
      subheadPart5: '.',
      ctaPrimary: 'Quanto estou deixando na mesa?',
      ctaSecondary: 'Antes, me mostra como funciona',
      statBlocks: 'escopo',
      statBlocksValue: '3 níveis',
      statSteps: 'caminho',
      statStepsValue: '6 etapas',
      statStatus: 'prazo',
      statStatusValue: '6 meses',
    },
    heroTerminal: {
      cmd: '> diagnóstico operacional',
      ok1: '✓ caminho do cliente mapeado',
      ok2: '✓ vazamentos identificados',
      ok3: '✓ método pronto para rodar',
      step1: '01 · atrair',
      step2: '02 · qualificar',
      step3: '03 · vender',
      step4: '04 · receber',
      step5: '05 · entregar',
      step6: '06 · reter',
      stepValue: 'R$ vazando',
      run: '... somando o seu dinheiro na mesa',
      titleBar: 'diagnóstico · ao vivo',
    },
    logosMarquee: {
      eyebrow: 'Empresas que confiam na Thux',
      titleMuted: 'Mais de 200 operações transformadas.',
      title: 'Resultado real em empresas de verdade.',
    },
    bigNumbers: {
      sectionEyebrow: 'Thux · Casa de Negócios',
      sectionTitle: 'A gente entra na sua operação e organiza tudo até o lucro aparecer no caixa.',
      yearsLabel: 'Anos de resultado · em empresa real',
      teamLabel: 'Especialistas no time · gente sênior, não freela',
      clientsLabel: 'Empresas atendidas · saúde, indústria, serviço, varejo',
      impactConvLabel: 'Mais vendas',
      impactConvSub: 'média entre clientes Thux',
      impactCostLabel: 'Menos custo',
      impactCostSub: 'corte de gastos inúteis e ferramentas redundantes',
      impactSpeedLabel: 'Mais velocidade',
      impactSpeedSub: 'do primeiro contato até o fechamento',
      impactGrowthLabel: 'Mais crescimento',
      impactGrowthSub: 'o dobro da média de mercado',
    },
    reality: {
      eyebrow: 'A realidade hoje',
      titleStrong: 'Você chegou aqui no braço.',
      titleMuted: 'Daqui para frente, só o braço não basta. A organização vai mandar.',
      blindSpotEyebrow: 'O ponto cego',
      blindSpotTitle: 'Cresceu trabalhando muito. Mas chegou no teto.',
      blindSpotBody: 'Você dobrou de tamanho. Contratou gente. Comprou software. Mas o lucro não cresceu junto. O resultado cai a cada nova contratação. O time não dá conta do que entra.',
      blindSpotBodyStrong: 'Trabalhar mais virou um teto, não uma alavanca.',
      blindSpotTagLabel: 'a verdade',
      blindSpotTagValue: 'SUOR > MÉTODO',
      profilesEyebrow: 'Quem passa por isso',
      profilesTitle: 'Mesma dor. Quatro tipos de empresa.',
      profilesSub: 'A história se repete em quem cresceu rápido e travou.',
      profileClinicTitle: 'Clínica que cresceu',
      profileClinicBody: 'Agenda cheia, custo alto, paciente novo não volta.',
      profileOfficeTitle: 'Escritório de serviço',
      profileOfficeBody: 'Projeto entra, o sócio vira gargalo, a margem não sobe.',
      profileIndustryTitle: 'Indústria e distribuidora',
      profileIndustryBody: 'Ciclo longo, vendedor perde o timing e a venda some.',
      profileCommerceTitle: 'Comércio especializado',
      profileCommerceBody: 'Atendimento humano não dá conta e o cliente desiste.',
      diagnosisEyebrow: 'O que falta',
      diagnosisTitle: 'Falta organização, não tecnologia.',
      diagnosisBody1: 'Você não precisa de mais ferramentas ou agências. Você precisa de ',
      diagnosisBodyStrong: 'um caminho organizado',
      diagnosisBody2: '. Cada etapa com dono, número e ritmo definido. Sem o Funil Completo, seu dinheiro vai pelo ralo.',
      indicatorHeader1: 'O que medir',
      indicatorHeader2: 'Como está hoje',
      indicator1Label: 'Tempo de resposta',
      indicator1Value: 'mais de 3 horas',
      indicator1Note: '(média)',
      indicator2Label: 'Conversão de leads',
      indicator2Value: '8% a 14%',
      indicator3Label: 'Taxa de retenção',
      indicator3Value: 'menos de 30%',
      indicator4Label: 'Custo de software',
      indicator4Value: '4% a 9%',
    },
    realityNow: {
      eyebrow: 'A realidade hoje',
      titlePart1: 'Você chegou aqui no braço.',
      titlePart2: 'Daqui para frente, só o braço não basta. A organização vai mandar.',
      card1Eyebrow: 'O ponto cego',
      card1Title: 'Cresceu muito. Mas chegou no teto.',
      card1Body1: 'Você dobrou de tamanho. Contratou gente, comprou software, contratou agência. Mas o lucro caiu a cada nova contratação. O time vive no limite. Você apaga incêndio toda semana.',
      card1BodyStrong: 'Trabalhar mais virou um teto, não uma alavanca.',
      card1TruthEyebrow: 'a verdade',
      card1TruthValue: 'SUOR > MÉTODO',
      card2Eyebrow: 'Quem passa por isso',
      card2Title: 'Mesma dor. Quatro tipos de empresa.',
      card2Body: 'A história se repete em quem cresceu rápido e travou. Bate o olho e identifica o seu.',
      perfis: [
        { title: 'Clínica que cresceu', body: 'Agenda cheia, custo por paciente subindo, paciente novo demora 4h pra ser atendido e some.' },
        { title: 'Escritório de serviço', body: 'Projeto entra, o sócio vira gargalo, proposta sai com 4h de trabalho e 60% não retorna.' },
        { title: 'Indústria e distribuidora', body: 'Lead da feira anotado em caderno, vendedor esquece de retornar, ciclo de venda passa de 6 meses sem motivo.' },
        { title: 'Comércio especializado', body: 'Cliente chega no Instagram, atendimento humano não dá conta, carrinho abandona em 80%.' },
      ],
      card3Eyebrow: 'O que falta',
      card3Title: 'Falta organização, não tecnologia.',
      card3Body1: 'Você não precisa de mais sistemas ou agências. Você precisa de ',
      card3BodyStrong: 'um caminho organizado',
      card3Body2: '. Cada etapa com dono, número e ritmo definido. Sem o Funil Completo, seu dinheiro vai pelo ralo.',
      metricsEyebrow1: 'O que medir',
      metricsEyebrow2: 'Como costuma estar hoje',
      indicadores: [
        { label: 'Tempo de resposta a um lead novo', value: 'mais de 3 horas', highlight: '(média)' },
        { label: 'De cada 100 interessados, quantos viram cliente', value: '8 a 14' },
        { label: 'De cada 100 clientes, quantos voltam em 12 meses', value: 'menos de 30' },
        { label: 'Quanto da receita evapora em ferramentas', value: '4% a 9%' },
      ],
      closingBridge: 'Em todos os 4 casos, o problema não é o time. É o caminho. E caminho a gente desenha. Não improvisa.',
      enemy: {
        eyebrow: 'O verdadeiro inimigo',
        title: 'Você não tem problema de ferramenta.',
        body: 'Você tem ferramenta demais que não conversa entre si, agência que se contradiz e planilha que ninguém atualiza. O Revenue AI não é mais um sistema na pilha. É o que faz tudo finalmente trabalhar junto. Ou sair.',
      },
    },
    gap: {
      eyebrow: 'A lacuna',
      titlePart1: 'Entre crescer e lucrar existe uma',
      titleAccent: 'camada inteira',
      titlePart2: 'que ninguém está montando.',
      body: 'Não é sua culpa. Você aprendeu a vender e operar o dia a dia. Mas ninguém ensinou a desenhar a estrutura que conecta tudo. É exatamente o que falta agora.',
      cmpAgencyLabel: 'Agência de marketing',
      cmpAgencyDelivers: 'traz o lead.',
      cmpSoftwareLabel: 'Empresa de software',
      cmpSoftwareDelivers: 'entrega a ferramenta.',
      cmpConsultLabel: 'Consultoria',
      cmpConsultDelivers: 'entrega relatório.',
      cmpThuxLabel: 'Thux',
      cmpThuxDelivers: 'organiza o caminho até a venda virar lucro.',
    },
    intervention: {
      eyebrow: 'A solução',
      titleStrong: 'Nós organizamos sua empresa de ponta a ponta para o lucro aparecer no caixa.',
      titleMutedPart1: '',
      titleMutedBrand: '',
      titleMutedPart2: '',
      description: 'Experiência prática, não promessa. O Método Prisma™ e a Revenue AI funcionam em empresas reais. Resolvemos gargalos onde o dinheiro aparece em 60 dias.',
      blocksEyebrow: 'As 4 frentes do trabalho',
      blocksTitle: 'Do bagunçado ao previsível.',
      block1Title: 'POSICIONAMENTO',
      block1Sub: 'fale com quem paga',
      block2Title: 'PRODUTO',
      block2Sub: 'oferta e margem',
      block3Title: 'CLIENTE NOVO',
      block3Sub: 'atração constante',
      block4Title: 'FECHAMENTO',
      block4Sub: 'venda sem desconto',
      bowtieEyebrow: 'Funil Completo · 6 etapas',
      bowtieTitle: 'O caminho inteiro, não só a venda.',
      bowtieAttract: 'Cliente novo',
      bowtieRetain: 'Retenção',
      bowtieDeal: 'fechou negócio',
      bowtieStep1: 'Atrair interessados',
      bowtieStep2: 'Qualificar o lead',
      bowtieStep3: 'Vender',
      bowtieStep3Hl: 'a venda fecha aqui',
      bowtieStep4: 'Receber bem',
      bowtieStep5: 'Entregar valor',
      bowtieStep6: 'Fazer recomprar',
      bowtieFooterPart1: 'A maioria tem só',
      bowtieFooterStrong1: '2 etapas organizadas',
      bowtieFooterPart2: '. As outras',
      bowtieFooterStrong2: '4 ficam no improviso',
      bowtieFooterPart3: '. O Funil Completo organiza as 6 com rotina, métricas e IA onde faz sentido.',
      ecosystemEyebrow: 'Como tudo se conecta',
      ecosystemTitle: 'Vender mais não é sorte. É um sistema montado.',
      ecosystemTop1: 'NÚMEROS',
      ecosystemTop2: 'ROTINA',
      ecosystemTop3: 'AVALIAÇÃO',
      ecosystemMid1: 'OPERAÇÃO',
      ecosystemMid2: 'QUALIDADE',
      ecosystemMid3: 'CRESCIMENTO',
      ecosystemCoreTitle: 'Revenue Architecture',
      ecosystemCore1: 'posiciona',
      ecosystemCore2: 'oferta',
      ecosystemCore3: 'atrai',
      ecosystemCore4: 'fecha',
      pillarsEyebrow: 'Por que Thux',
      pillarsTitleStrong: 'Seis motivos pra confiar.',
      pillarsTitleMuted: 'Experiência prática, não promessa de marketing.',
      pillar1Title: 'Casa de Negócios. Não software.',
      pillar1Body: 'Não vendemos ferramentas. Organizamos o trabalho do começo ao fim. Software é meio. O fim é dinheiro no caixa.',
      pillar2Title: 'Método Prisma™. Dinheiro que estava escondido.',
      pillar2Body: 'Olhamos sua empresa por quatro lados e encontramos os vazamentos. Transformamos cada um em ação com prazo, dono e número.',
      pillar2Quote: 'O Prisma permite mostrar três oportunidades de receita em 60 dias que ninguém estava vendo.',
      pillar3Title: 'Revenue AI. Inteligência com objetivo.',
      pillar3Body: 'IA não é enfeite. É automação aplicada onde devolve velocidade e conversão. Com número combinado e painel acompanhando.',
      pillar4Title: 'Time dedicado. Especialistas plugados.',
      pillar4Body: 'Produto, dados, automação, texto e operação. Trabalhando como seu próprio time. Sem freelancer sumindo ou agência empurrando entregas.',
      pillar5Title: 'Mais de 200 empresas. 5 anos de campo.',
      pillar5Body: 'Saúde, educação, serviços, indústria e tecnologia. Casos com números reais. Autoridade construída em resultado, não em post.',
      pillar6Title: 'Resultado combinado ou não começa.',
      pillar6Body: 'Definimos o número antes. Se não movermos o ponteiro combinado, o trabalho vira diagnóstico sem custo. Sem surpresas.',
    },
    prisma: {
      eyebrow: 'Método Prisma™ · 4 lados',
      title: 'Encontre o dinheiro escondido. Recupere sua receita todo mês.',
      description: 'O Prisma é o método próprio da Thux. Funciona como um cristal: a mesma empresa, olhada por quatro lados, revela oportunidades invisíveis.',
      face1: 'MOSTRA',
      tab1: 'Diagnóstico',
      face1Title: 'Mapeia tudo. Encontra onde vaza dinheiro.',
      face1Body: 'Desenhamos o caminho completo do seu cliente. Mostramos em reais onde você perde venda, lucro e tempo. Sem chute.',
      face2: 'ESCOLHE',
      tab2: 'Prioridade',
      face2Title: 'Separa o que dá caixa agora do que é projeto eterno.',
      face2Body: 'Colocamos na fila apenas o que vira receita em 60 dias. O resto espera. Foco no que faz a empresa andar agora.',
      face3: 'INSTALA',
      tab3: 'Instalação',
      face3Title: 'IA trabalhando nos pontos certos.',
      face3Body: 'A automação entra onde gera resultado: resposta imediata, organização de atendimento e recuperação de vendas. Tecnologia para o caixa subir.',
      face4: 'ACOMPANHA',
      tab4: 'Resultado',
      face4Title: 'Número combinado antes. Painel toda semana.',
      face4Body: 'Cada trabalho começa com meta clara. Quanto sobe em venda e quanto cai em custo. Painel atualizado e reunião semanal. Sem "depende".',
      illTagLost: 'Venda perdida',
      illTagChurn: 'Cliente que sai',
      illTagProfit: 'Lucro escondido',
      illTagCost: 'Custo otimizável',
    },
    product: {
      eyebrow: 'O produto · Revenue AI',
      title: 'Máquina de Receita Previsível Inteligente.',
      titleAccent: 'Em 3 escopos.',
      description: 'Você não precisa começar pelo todo. A Thux instala a quantidade de funil que faz sentido pro tamanho da sua empresa hoje, e vai expandindo conforme você cresce. Mesma metodologia, mesmo time, mesmo acompanhamento semanal. O que muda é o quanto da sua operação a Thux organiza.',
      funnelEyebrow: 'O Funil Completo · 6 etapas',
      funnelTitle: 'O caminho inteiro do seu cliente.',
      funnelHelper: 'Clique nos escopos abaixo para ver o que cada um cobre.',
      bowtie: {
        s1: 'Atrair',
        s2: 'Qualificar',
        s3: 'Vender',
        s4: 'Receber',
        s5: 'Entregar',
        s6: 'Recomprar',
        deal: 'Fechou negócio',
        attractEyebrow: 'Cliente novo',
        retainEyebrow: 'Retenção',
      },
      scopesEyebrow: 'Os 3 escopos',
      scopesTitle: 'Comece no escopo que faz sentido hoje.',
      premiumLabel: 'Premium',
      premiumPositioning: 'Funil inteiro virando motor',
      premiumFor: 'Pra quem vende e entrega bem, mas o dono ainda está afogado no dia a dia em vez de comandar a empresa.',
      premiumCovers: 'Funil completo · etapas 1 a 6',
      premiumOutcome: 'Cliente recompra sozinho, indica sozinho, e a operação vira motor de receita previsível.',
      avancadoLabel: 'Avançado',
      avancadoPositioning: 'Caminho do meio organizado',
      avancadoFor: 'Pra quem fecha venda, mas perde o cliente depois. Sócio ainda gargalo no meio: segurando entrega, qualidade e recompra.',
      avancadoCovers: 'Topo + meio · etapas 1 a 5',
      avancadoOutcome: 'Cliente novo entra, é recebido, começa a usar e enxerga valor sem o sócio na cola. Satisfação subindo, cliente parando de sair.',
      essencialLabel: 'Essencial',
      essencialPositioning: 'Topo do funil organizado',
      essencialFor: 'Pra quem perde cliente novo na porta de entrada. Contato chega, demora pra ser respondido, e evapora antes de virar venda.',
      essencialCovers: 'Topo · etapas 1 a 3',
      essencialOutcome: 'Cliente novo respondido em 3 minutos, filtrado pela IA, agendado direto na agenda. O sócio para de fazer atendimento.',
      upgradeBridge: 'Você começa no escopo que faz sentido hoje. Quando a operação responder, expandimos sem reiniciar.',
      inAllEyebrow: 'Em todos os escopos',
      inAll1: '6 meses de implementação com o time Thux dentro da sua empresa',
      inAll2: 'Acompanhamento semanal · 4 sessões/mês',
      inAll3: 'Diagnóstico R.I.C.O. + Plano Mestre com número combinado antes',
      inAll4: 'Painel de números atualizado toda semana',
      guaranteeEyebrow: 'Garantia',
      guaranteeBody: 'Se em 6 meses não atingirmos pelo menos 70% do número combinado, estendemos 60 dias sem custo OU devolvemos parte do investimento. Sua escolha.',
      guaranteeFootnote: 'O número de cada escopo é fechado no Diagnóstico R.I.C.O., assinado pelos dois lados, antes de começar.',
      ctaButton: 'Quero saber qual escopo encaixa na minha empresa',
      ctaMicrocopy: 'O escopo é definido junto com você no diagnóstico gratuito. Sem pacote vendido às cegas.',
    },
    cases: {
      eyebrow: 'Cases de sucesso',
      titlePart1: 'Resultados que entregamos',
      titleAccent: 'em empresas reais.',
      description: 'Números literais. Venda recuperada, custo cortado e retorno comprovado. Tudo começou com o diagnóstico.',
      case1Desc: 'Plataforma de conteúdo e assinaturas. Organizamos o caminho do cliente e reduzimos a saída de usuários.',
      case1Tag1: '−30% de cliente saindo',
      case1Tag2: '+100% em vendas',
      case2Desc: 'Empresa de atendimento multicanal. Estruturamos o processo de venda e a filtragem de contatos novos.',
      case2Tag1: '+400% em clientes',
      case2Tag2: '+100% em vendas',
      case3Desc: 'Automação de WhatsApp. Aplicamos IA no fechamento e acompanhamento de oportunidades.',
      case3Tag1: '−36% de cliente saindo',
      case3Tag2: '+10% em vendas',
      case3Tag3: '5× mais retorno',
    },
    money: {
      eyebrow: 'A prova em números',
      titlePart1: 'Quanto dinheiro está vazando da sua empresa',
      titleAccent: 'agora?',
      description: 'Quatro vazamentos comuns em operações de R$ 1M a R$ 15M. A calculadora não chuta. Ela mostra a conta que seu negócio já está pagando hoje.',
      totalEyebrow: 'Soma dos 4 vazamentos',
      totalTitlePart1: 'Dinheiro que vaza da sua operação,',
      totalTitleAccent: 'por ano:',
      totalBody1: 'Essa é a diferença entre trabalhar com a Thux e continuar como está hoje. Não é promessa.',
      totalBodyStrong: 'É a conta real do seu próprio negócio.',
      breakdown1: 'Venda perdida',
      breakdown2: 'Lucro perdido',
      breakdown3: 'Cliente que não voltou',
      breakdown4: 'Gasto otimizável',
      ctaButton: 'Quero o diagnóstico da minha empresa',
      ctaMicrocopy: '60 minutos · gratuito · sem venda forçada',
      navStep: 'Etapa',
      navOf: 'de',
      navResult: 'Resultado final',
      navBack: 'Voltar',
      navContinue: 'Continuar',
      navSeeTotal: 'Ver o total',
    },
    calc1: {
      title: 'Venda perdida',
      subtitle: 'Lead que chega e ninguém atende rápido',
      tooltip: 'Cliente atendido em 5 minutos compra até 21 vezes mais. Esta conta mostra quanto você deixa de vender pela demora na resposta.',
      f1: 'Leads novos por mês',
      f1Suffix: 'por mês',
      f2: '% atendido em 5 minutos',
      f3: 'Ticket médio',
      f4: 'Conversão atual',
      f5: 'Conversão projetada com resposta rápida',
      monthly: 'Perda mensal',
      yearly: 'Perda anual',
    },
    calc2: {
      title: 'Lucro perdido na venda',
      subtitle: 'Proposta feita que não vira fechamento',
      tooltip: '80% das vendas precisam de 5 ou mais retornos. Esta conta mostra o lucro perdido quando o vendedor desiste cedo demais.',
      f1: 'Reuniões por mês',
      f1Suffix: 'por mês',
      f2: '% de reunião que vira proposta',
      f3: '% de fechamento atual',
      f4: '% de fechamento projetado com acompanhamento',
      f5: 'Ticket médio',
      monthly: 'Perda mensal',
      yearly: 'Perda anual',
    },
    calc3: {
      title: 'Cliente que não voltou',
      subtitle: 'Quem comprou uma vez e sumiu',
      tooltip: 'Aumentar a retenção em 5% pode subir o lucro em até 95%. Esta conta mostra o prejuízo de tratar cliente como venda única.',
      f1: 'Clientes no último ano',
      f1Suffix: 'clientes',
      f2: '% de recompra atual',
      f3: '% de recompra projetada com relacionamento',
      f4: 'Valor da recompra',
      yearly: 'Perda anual',
    },
    calc4: {
      title: 'Gasto otimizável',
      subtitle: 'Softwares inúteis e tarefas manuais repetitivas',
      tooltip: 'Empresas perdem até 30% do gasto com sistemas redundantes. IA pode automatizar 60% das tarefas manuais do seu time.',
      f1: 'Gasto mensal com softwares',
      f1Suffix: 'R$/mês',
      f2: 'Horas do time em tarefas manuais',
      f2Suffix: 'horas/mês',
      f3: 'Custo da hora do time',
      f3Suffix: 'R$/h',
      f4: '% otimizável com método e IA',
      monthly: 'Economia mensal',
      yearly: 'Economia anual',
    },
    outcome: {
      eyebrow: 'O resultado lá na frente',
      titlePart1: 'O que muda em',
      titleAccent1: '90 dias',
      titlePart2: ', em',
      titleAccent2: '6 meses',
      titlePart3: ' e em',
      titleAccent3: '12 meses',
      titlePart4: '.',
      h1Metric: '90 dias',
      h1Title: 'Caminho mapeado e vazamentos estancados.',
      h1Body: 'Desenhamos o caminho do cliente e resolvemos as 3 maiores travas. Você sai do operacional e começa a acompanhar os números reais.',
      h2Metric: '6 meses',
      h2Title: 'Venda previsível e lucro de volta.',
      h2Body: 'As 6 etapas do funil com rotina. Leads sempre respondidos e clientes voltando. Time focado no que importa e custos enxugados.',
      h3Metric: '12 meses',
      h3Title: 'A empresa trabalha por você.',
      h3Body: 'O lucro voltou e a venda virou uma engrenagem. Empresa pronta para expandir, contratar com segurança e abrir novos mercados.',
      stat1: 'Frentes de trabalho',
      stat2: 'Etapas do caminho',
      stat3: 'Anos de experiência',
    },
    testimonials: {
      bannerTitle: 'IA que trabalha pelo seu negócio enquanto você cuida da estratégia',
      m1Value: '+87%',
      m1Label: 'em vendas',
      m2Value: '−40%',
      m2Label: 'no custo',
      m3Value: '3×',
      m3Label: 'mais rápido',
      m4Value: '+ Lucro',
      m4Label: 'no caixa',
      eyebrow: 'Resultados reais',
      titlePart1: 'O que aconteceu depois que entramos',
      titleAccent: 'na operação.',
      description: 'Depoimentos de quem decidiu crescer com organização, não no braço.',
      featuredBadge: 'destaque',
      role: {
        founder: 'Fundador',
        ceo: 'CEO',
      },
      t1: 'Reduzimos a saída de clientes em 30% e aumentamos as vendas em 10%. O produto ficou muito mais profissional com a metodologia da Thux.',
      t2: 'Crescemos 400% em clientes e dobramos as reuniões que viram venda. Eles foram peça-chave no nosso sucesso.',
      t3: 'Trouxeram clareza, consistência e usabilidade. Antes a interface era confusa e a identidade visual fraca.',
      t4: 'Surpreenderam no atendimento e na entrega. Apoio fundamental para avançarmos com qualidade.',
      t5: 'Muito felizes com o resultado da validação. Parceria de altíssimo nível.',
    },
    howStarts: {
      eyebrow: 'Como começa',
      titlePart1: 'A primeira etapa não é proposta.',
      titleAccent: 'É diagnóstico.',
      description1: 'Começamos com uma',
      descriptionStrong: 'conversa de 60 minutos',
      description2: '. Mapeamos onde sua empresa perde dinheiro e o caminho mais curto para recuperar. Sem cobrança e sem venda forçada.',
      outputStrong: 'O que você leva:',
      outputBody: 'um mapa do caminho do cliente com os 3 maiores vazamentos e o valor de cada um em reais. Você decide o próximo passo.',
      step1Day: 'Hoje',
      step1Title: 'Formulário rápido',
      step1Body: 'Cinco perguntas sobre faturamento e problemas atuais. Leva 1 minuto e nos permite chegar preparados.',
      step2Day: 'Em 2 dias',
      step2Title: 'Agenda marcada',
      step2Body: 'Você recebe o convite para a reunião. 60 minutos com um especialista que entende do seu setor.',
      step3Day: 'Em 5 dias',
      step3Title: 'Diagnóstico ao vivo',
      step3Body: 'Analisamos as 6 etapas do seu funil. Mostramos os 3 pontos onde vaza dinheiro e calculamos o valor real de cada um.',
      step4Day: 'Em 7 dias',
      step4Title: 'Mapa por escrito',
      step4Body: 'Você recebe o documento com o caminho do cliente e os vazamentos identificados. O mapa é seu.',
      step5Day: 'Em 10 dias',
      step5Title: 'A decisão',
      step5Body: 'Se fizer sentido, apresentamos o escopo (Essencial, Avançado ou Premium). Se não, você segue com o diagnóstico em mãos.',
      ctaButton: 'Quero o diagnóstico gratuito',
      ctaWhats: 'WhatsApp',
    },
    faq: {
      eyebrow: 'Perguntas Frequentes',
      title: 'Ficou alguma dúvida?',
      description: 'Tudo às claras antes mesmo da nossa primeira conversa.',
      items: [
        { q: 'Thux é agência de marketing?', a: 'Não. Somos uma Casa de Negócios. Agência traz contato. Empresa de software entrega ferramenta. Consultoria entrega relatório. A Thux organiza o caminho inteiro, do primeiro contato até a recompra, instalando IA onde faz sentido e treinando seu time pra operar.' },
        { q: 'Quanto custa?', a: 'Não há preço de prateleira. O escopo é definido no diagnóstico: Essencial, Avançado ou Premium, conforme o tamanho da sua operação e o tamanho do que vamos resolver. Sem retorno projetado claro, não começamos.' },
        { q: 'O que é o diagnóstico gratuito?', a: 'Reunião de 60 minutos onde aplicamos o Método Prisma. Você traz seus números (faturamento, margem, custo de aquisição). Mapeamos onde o dinheiro está vazando e o tamanho do que pode ser recuperado. O documento é seu mesmo se não fecharmos.' },
        { q: 'Funciona pra minha empresa?', a: 'Funciona se você fatura entre R$ 1M e R$ 15M/ano e sente que a operação virou seu gargalo. Saúde, serviço, indústria, varejo especializado e tecnologia são nossos focos principais.' },
        { q: 'Em quanto tempo vejo resultado?', a: 'Implementação completa em 6 meses. Mas as primeiras semanas já costumam destravar dinheiro parado: cliente novo esquecido, cliente que não voltou, proposta sem retorno. Painel atualizado toda semana, reunião pra ajustar rota.' },
        { q: 'E se não atingir o número combinado?', a: 'Garantia clara: se em 6 meses não atingirmos pelo menos 70% do que combinamos, estendemos 60 dias sem custo OU devolvemos parte do investimento. Sua escolha. Isso só é possível porque qualificamos cirurgicamente quem entra.' },
      ],
    },
    decision: {
      eyebrow: 'A decisão',
      titlePart1: 'Sua empresa vai começar o próximo ano igual hoje, ou',
      titleAccent: 'com a Thux organizando tudo?',
      description: 'A conta está na sua frente. Você pode continuar esperando que trabalhar mais resolva, ou começar a estancar os vazamentos em 90 dias.',
      ctaButton: 'Quero o diagnóstico gratuito',
      ctaWhats: 'WhatsApp',
    },
    footer: {
      tagline: 'Casa de Negócios',
      legalNotice: 'Thux · Casa de Negócios. Resultados reais de clientes reais. Cada caso depende da execução e comprometimento da empresa.',
      privacy: 'Privacidade',
      terms: 'Termos',
    },
    sticky: {
      cta: 'Diagnóstico gratuito · 60 min · sem venda forçada',
    },
    modal: {
      pill: 'Diagnóstico · 60 min · gratuito',
      title: 'Vamos mapear sua empresa.',
      description: 'Cinco perguntas rápidas pra chegarmos preparados.',
      fieldName: 'Nome',
      fieldNamePh: 'Seu nome',
      fieldWhats: 'WhatsApp',
      fieldWhatsPh: '+55 11 99999-9999',
      fieldEmail: 'Email',
      fieldEmailPh: 'seu@email.com',
      fieldRevenue: 'Faturamento anual',
      revenueSelect: 'Selecione',
      revenue1: 'Abaixo de R$ 1M',
      revenue2: 'R$ 1M a R$ 5M',
      revenue3: 'R$ 5M a R$ 15M',
      revenue4: 'Acima de R$ 15M',
      fieldGap: 'Maior problema hoje',
      gapSelect: 'Escolha um',
      gap1: 'Atrair clientes qualificados',
      gap2: 'Fechar mais vendas',
      gap3: 'Fazer o cliente recomprar',
      gap4: 'Cortar custos operacionais',
      gap5: 'Sair do operacional',
      fieldDecisor: 'Você decide a contratação?',
      decisor1: 'Sou dono ou sócio',
      decisor2: 'Sou diretor decisor',
      decisor3: 'Decido com sócio',
      decisor4: 'Levo para quem decide',
      submit: 'Receber convite no WhatsApp',
      submitting: 'Enviando…',
      microcopy: 'Dados protegidos. Sem spam ou venda forçada.',
      successTitlePart1: 'Recebemos.',
      successTitleAccent: 'Em até 48h você recebe o convite no WhatsApp.',
      successBody1: 'Confira nosso Instagram.',
      successBody2: ' Conteúdo diário sobre operação e lucro.',
      successCta: 'Instagram',
      successClose: 'Fechar',
      errorRequired: 'Obrigatório',
      errorName: 'Informe seu nome',
      errorWhats: 'WhatsApp inválido',
      errorWhatsFormat: 'Apenas números',
      errorEmail: 'Email inválido',
    },
  },

  en: {
    nav: {
      tagline: 'Business House',
      howItWorks: 'How it works',
      product: 'Product',
      calculator: 'Calculator',
      howItStarts: 'How it starts',
      cta: 'Diagnosis',
      langLabel: 'Language',
    },
    hero: {
      eyebrow: 'revenue architecture · live',
      headline1: 'Your company grew.',
      headline2: 'Your operation didn\'t.',
      headline3: 'And what\'s at risk',
      headline4: 'now is your profit.',
      subheadPart1: 'Companies between',
      subheadAmount: 'R$ 1M and R$ 15M',
      subheadPart2: '? ',
      subheadBrand1: 'Thux',
      subheadPart3: ' steps in, organizes everything from start to finish with the ',
      subheadBrand2: 'Prisma Method™',
      subheadPart4: ' and puts ',
      subheadBrand3: 'artificial intelligence',
      subheadPart5: ' where it makes a difference — so you earn more, spend less, and have time again. In 60 days.',
      ctaPrimary: 'Find out how much is leaking',
      ctaSecondary: 'See how it works',
      statBlocks: 'fronts',
      statBlocksValue: '4 areas',
      statSteps: 'path',
      statStepsValue: '6 steps',
      statStatus: 'timeline',
      statStatusValue: '60 days',
    },
    heroTerminal: {
      cmd: '> diagnosis of your company',
      ok1: '✓ customer journey mapped',
      ok2: '✓ leak points identified',
      ok3: '✓ method ready to run',
      step1: '01 · attract',
      step2: '02 · qualify',
      step3: '03 · sell',
      step4: '04 · onboard',
      step5: '05 · deliver',
      step6: '06 · bring back',
      stepValue: 'R$ leaking',
      run: '... summing up your money on the table',
      titleBar: 'diagnosis · live',
    },
    logosMarquee: {
      eyebrow: 'Companies that work with Thux',
      titleMuted: 'More than 200 companies served.',
      title: 'Proven results in real companies.',
    },
    bigNumbers: {
      sectionEyebrow: 'Thux · Business House',
      sectionTitle: 'The company that steps into your operation and organizes everything to deliver results.',
      yearsLabel: 'Years delivering results',
      teamLabel: 'Professionals on the Thux team',
      clientsLabel: 'Companies served',
      impactConvLabel: 'More in sales',
      impactConvSub: 'average increase among clients',
      impactCostLabel: 'Less in cost',
      impactCostSub: 'cuts on tools and team time',
      impactSpeedLabel: 'Faster to close',
      impactSpeedSub: 'from first contact to sale',
      impactGrowthLabel: 'More growth',
      impactGrowthSub: 'companies using AI with method grow twice as fast',
    },
    reality: {
      eyebrow: 'The reality today',
      titleStrong: 'You got here through grit.',
      titleMuted: 'From here on, grit isn\'t enough. What rules now is organization.',
      blindSpotEyebrow: 'The blind spot',
      blindSpotTitle: 'You grew by working hard. But hit the ceiling.',
      blindSpotBody: 'You doubled in size. Hired more people. Bought more tools. But profit didn\'t grow with it. You keep operating, the result shrinks with each new hire, and the team can\'t handle what comes in.',
      blindSpotBodyStrong: 'Working harder became a ceiling, not a lever.',
      blindSpotTagLabel: 'the truth',
      blindSpotTagValue: 'SWEAT > ORGANIZATION',
      profilesEyebrow: 'Who\'s going through this',
      profilesTitle: 'Same pain. Four kinds of company.',
      profilesSub: 'The story repeats in those who grew fast and got stuck.',
      profileClinicTitle: 'Growing clinic',
      profileClinicBody: 'Full schedule, expensive marketing, new patients take long to return.',
      profileOfficeTitle: 'Service firm',
      profileOfficeBody: 'Project comes in, partner becomes the bottleneck, value per job won\'t go up.',
      profileIndustryTitle: 'Industry & distribution',
      profileIndustryBody: 'Sells B2B, long cycle, salesperson forgets to follow up, opportunity vanishes.',
      profileCommerceTitle: 'Specialty commerce',
      profileCommerceBody: 'Customer comes via Instagram, human service can\'t scale, the sale escapes.',
      diagnosisEyebrow: 'What\'s missing',
      diagnosisTitle: 'You lack organization, not technology.',
      diagnosisBody1: 'You don\'t need more tools, more software, more agencies. You need ',
      diagnosisBodyStrong: 'an organized path',
      diagnosisBody2: ' — where each step has an owner, a number to track, and a defined rhythm. Those are the 6 stages of the Full Funnel. Without it, any money invested in marketing, sales or AI goes down the drain.',
      indicatorHeader1: 'What to measure',
      indicatorHeader2: 'How it stands today',
      indicator1Label: 'Time to respond to a new lead',
      indicator1Value: 'over 3 hours',
      indicator1Note: '(average)',
      indicator2Label: 'Out of 100 prospects, how many become clients',
      indicator2Value: '8 to 14',
      indicator3Label: 'How many clients buy again within 12 months',
      indicator3Value: 'less than 30%',
      indicator4Label: 'How much of revenue goes to software',
      indicator4Value: '4% to 9%',
    },
    realityNow: {
      eyebrow: 'Reality today',
      titlePart1: 'You got this far on grit.',
      titlePart2: 'From now on, grit isn\'t enough. Organization is what dictates growth.',
      card1Eyebrow: 'The blind spot',
      card1Title: 'You grew by working hard. But you hit the ceiling.',
      card1Body1: 'You doubled in size. Hired more people. Bought more tools. But profit didn\'t grow with it. You\'re still operating, the result gets smaller with each new hire, and the team can\'t handle what comes in. ',
      card1BodyStrong: 'Working harder became a ceiling, not a lever.',
      card1TruthEyebrow: 'the truth',
      card1TruthValue: 'SWEAT > ORGANIZATION',
      card2Eyebrow: 'Who goes through this',
      card2Title: 'Same pain. Four types of companies.',
      card2Body: 'The story repeats for those who grew fast and stalled.',
      perfis: [
        { title: 'Clinic that grew', body: 'Full schedule, expensive ads, new patients take too long to return.' },
        { title: 'Service firm', body: 'Project comes in, the partner becomes the bottleneck, value per job doesn\'t increase.' },
        { title: 'Industry & distributors', body: 'B2B sales, long cycles, salespeople forget to follow up and opportunities vanish.' },
        { title: 'Specialized commerce', body: 'Customers arrive via Instagram, human support can\'t keep up, and sales slip away.' },
      ],
      card3Eyebrow: 'What is missing',
      card3Title: 'You lack organization, not technology.',
      card3Body1: 'You don\'t need another tool, system, or agency. You need ',
      card3BodyStrong: 'an organized path',
      card3Body2: ' — where every work stage has an owner, a number to track, and a defined rhythm. These are the 6 stages of the Full Funnel. Without it, any money invested in marketing, sales, or AI goes down the drain.',
      metricsEyebrow1: 'What to measure',
      metricsEyebrow2: 'Where it stands today',
      indicadores: [
        { label: 'Time to respond to a new lead', value: 'over 3 hours', highlight: '(on average)' },
        { label: 'Out of 100 prospects, how many become clients', value: '8 to 14' },
        { label: 'How many clients buy again in 12 months', value: 'under 30%' },
        { label: 'How much of revenue goes to software tools', value: '4% to 9%' },
      ],
      closingBridge: 'In all 4 cases, the problem is not the team. It is the path. And the path is something we design. Not improvise.',
      enemy: {
        eyebrow: 'The real enemy',
        title: 'You don\'t have a tool problem.',
        body: 'You have too many tools that don\'t talk to each other, agencies that contradict themselves, and a spreadsheet no one updates. Revenue AI is not another system in the stack. It is what makes everything finally work together. Or leave.',
      },
    },
    gap: {
      eyebrow: 'The gap',
      titlePart1: 'Between growing and having profit there\'s a',
      titleAccent: 'whole layer',
      titlePart2: 'no one is building.',
      body: 'It\'s not your fault. Entrepreneurs learned to operate, sell, hire and run the day-to-day. But no one taught how to design the structure that makes all that work together — and that\'s exactly what\'s missing now.',
      cmpAgencyLabel: 'Marketing agency',
      cmpAgencyDelivers: 'brings in more new customers.',
      cmpSoftwareLabel: 'Software company',
      cmpSoftwareDelivers: 'delivers the tool.',
      cmpConsultLabel: 'Consultancy',
      cmpConsultDelivers: 'delivers a report with recommendations.',
      cmpThuxLabel: 'Thux',
      cmpThuxDelivers: 'steps into your company and organizes all of it to deliver results.',
    },
    intervention: {
      eyebrow: 'The solution',
      titleStrong: 'Thux is not a software company.',
      titleMutedPart1: 'It is a',
      titleMutedBrand: 'Business House',
      titleMutedPart2: '— it steps into your company, organizes everything from start to finish, and the result shows up in your cash flow.',
      description: 'Six reasons to trust the work. Each one is practical experience, not a marketing promise. The Prisma Method™ and Revenue AI were born running in real companies — first at Thux, then at clients — before becoming an offer.',
      blocksEyebrow: 'The 4 fronts of the work',
      blocksTitle: 'From messy to predictable.',
      block1Title: 'POSITIONING',
      block1Sub: 'who you talk to',
      block2Title: 'PRODUCT',
      block2Sub: 'price and offer',
      block3Title: 'NEW CUSTOMER',
      block3Sub: 'predictable path',
      block4Title: 'CLOSING',
      block4Sub: 'sale without discount',
      bowtieEyebrow: 'Full Funnel · 6 stages',
      bowtieTitle: 'The whole path, not just the sale.',
      bowtieAttract: 'New customer',
      bowtieRetain: 'Retention',
      bowtieDeal: 'closed deal',
      bowtieStep1: 'Attract a new customer',
      bowtieStep2: 'Know if they fit you',
      bowtieStep3: 'Sell',
      bowtieStep3Hl: 'the sale closes here',
      bowtieStep4: 'Welcome them well',
      bowtieStep5: 'Deliver with quality',
      bowtieStep6: 'Make them buy again',
      bowtieFooterPart1: 'Most companies have only',
      bowtieFooterStrong1: '2 organized stages',
      bowtieFooterPart2: '(attract and sell) and',
      bowtieFooterStrong2: '4 improvised stages',
      bowtieFooterPart3: '. The Full Funnel organizes all 6 with routine, numbers to track and AI — where it makes sense, as much as it makes sense.',
      ecosystemEyebrow: 'How it all connects',
      ecosystemTitle: 'Selling more isn\'t luck. It\'s a well-built system.',
      ecosystemTop1: 'NUMBERS',
      ecosystemTop2: 'ROUTINE',
      ecosystemTop3: 'REVIEW',
      ecosystemMid1: 'OPERATION',
      ecosystemMid2: 'QUALITY',
      ecosystemMid3: 'GROWTH',
      ecosystemCoreTitle: 'Revenue Architecture',
      ecosystemCore1: 'positions',
      ecosystemCore2: 'offer',
      ecosystemCore3: 'new customer',
      ecosystemCore4: 'closes',
      pillarsEyebrow: 'Why Thux',
      pillarsTitleStrong: 'Six reasons to trust.',
      pillarsTitleMuted: 'Each is practical experience, not a marketing promise.',
      pillar1Title: 'Business House. Not a software company.',
      pillar1Body: 'Thux doesn\'t sell tools. Thux steps into your company, organizes the work from end to end, and the result shows up directly in your profit. Software is means. The end is cash in the bank.',
      pillar2Title: 'Prisma Method™ — finds money that was hidden.',
      pillar2Body: 'Every company has money leaking without noticing. Prisma is the Thux method that looks at your company from four sides, finds those leaks and turns each one into an action with a deadline, owner and number.',
      pillar2Quote: 'Prisma is what allows Thux to step into any company and, in 60 days, show three revenue opportunities no one was seeing.',
      pillar3Title: 'Revenue AI · artificial intelligence with a clear goal.',
      pillar3Body: 'AI is not decoration. It\'s not "let\'s put a bot to answer". It\'s artificial intelligence applied at the exact spot where it returns speed, consistency and more sales — with a number agreed before and a dashboard tracking after.',
      pillar4Title: 'Dedicated team · over 30 professionals.',
      pillar4Body: 'Full team — product, data, automation, copy and ops people — working as if it were your own team. No freelancer disappearing, no agency pushing deliverables. Operation plugged into your real business.',
      pillar5Title: 'Over 200 companies served. Over 5 years in the field.',
      pillar5Body: 'Clients in healthcare, education, services, industry and tech. Cases with real numbers — recovered sales, churn that stopped, cost cut. Authority built on client results. Not on Instagram posts.',
      pillar6Title: 'Agreed result, or it doesn\'t start.',
      pillar6Body: 'The number is set before the work. Weekly dashboard, follow-up meeting, 60-day deadline. If Thux steps in and doesn\'t move the agreed number, it\'s because the number was wrong or the company wasn\'t ready — and that becomes a diagnosis, not a bill.',
    },
    prisma: {
      eyebrow: 'Prisma Method™ · 4 sides',
      title: 'Finds the hidden money. Turns it into recurring revenue.',
      description: 'Prisma is Thux\'s own method. It works like a crystal: the same company, looked at from four different sides, shows opportunities that were right there — but no one saw.',
      face1: 'SHOWS',
      tab1: 'Diagnosis',
      face1Title: 'Looks at everything. Finds where money is leaking.',
      face1Body: 'Thux maps the entire customer journey — from when they discover your company until they buy again. And shows, in dollars, where sales, profit and time are leaking. No guessing.',
      face2: 'CHOOSES',
      tab2: 'Priority',
      face2Title: 'Separates what brings money now from eternal projects.',
      face2Body: 'You can\'t fix everything at once. We only put in the queue what comes back as revenue in 60 days. The rest waits. No long-term promises, just what makes the company move now.',
      face3: 'INSTALLS',
      tab3: 'Installation',
      face3Title: 'Puts AI to work at the right spots.',
      face3Body: 'AI goes where it brings results: answering new customers instantly, organizing service, reminding to follow up, helping the customer come back. Not technology for fashion. Technology that lifts the cash flow.',
      face4: 'TRACKS',
      tab4: 'Result',
      face4Title: 'Agrees the number first. Tracks every week.',
      face4Body: 'Each project starts with a clear number: how much sales will go up, how much cost will drop. Dashboard updated daily, meeting weekly. No surprise. No "it depends".',
      illTagLost: 'Lost sales',
      illTagChurn: 'Churning customer',
      illTagProfit: 'Hidden profit',
      illTagCost: 'Optimizable cost',
    },
    product: {
      eyebrow: 'The product · Revenue AI',
      title: 'Predictable Revenue Intelligence Machine.',
      titleAccent: 'In 3 scopes.',
      description: 'You don\'t need to start with the whole thing. Thux installs the amount of funnel that fits your company today, and expands it as you grow. Same methodology, same team, same weekly support. What changes is how much of your operation Thux organizes.',
      funnelEyebrow: 'The Full Funnel · 6 stages',
      funnelTitle: 'The whole customer path.',
      funnelHelper: 'Click each scope below to see what it covers.',
      bowtie: {
        s1: 'Attract',
        s2: 'Qualify',
        s3: 'Sell',
        s4: 'Onboard',
        s5: 'Deliver',
        s6: 'Bring back',
        deal: 'Deal closed',
        attractEyebrow: 'New customer',
        retainEyebrow: 'Retention',
      },
      scopesEyebrow: 'The 3 scopes',
      scopesTitle: 'Start with the scope that fits today.',
      premiumLabel: 'Premium',
      premiumPositioning: 'Whole funnel as an engine',
      premiumFor: 'For those who sell and deliver well, but the owner is still drowning in day-to-day work instead of leading the company.',
      premiumCovers: 'Full funnel · stages 1 to 6',
      premiumOutcome: 'Customer buys again on their own, refers others, and the operation becomes a predictable revenue engine.',
      avancadoLabel: 'Advanced',
      avancadoPositioning: 'Middle path organized',
      avancadoFor: 'For those who close the sale, but lose the customer after. Partner still the bottleneck in the middle: holding delivery, quality and repeat purchase.',
      avancadoCovers: 'Top + middle · stages 1 to 5',
      avancadoOutcome: 'New customer enters, is welcomed, starts using and sees value without the partner watching. Satisfaction climbing, customers staying.',
      essencialLabel: 'Essential',
      essencialPositioning: 'Top of funnel organized',
      essencialFor: 'For those who lose new customers at the front door. Contact arrives, takes too long to be answered, and vanishes before becoming a sale.',
      essencialCovers: 'Top · stages 1 to 3',
      essencialOutcome: 'New customer answered in 3 minutes, filtered by AI, scheduled directly on the calendar. Partner stops doing front-line service.',
      upgradeBridge: 'You start with the scope that fits today. When operations respond, we expand without restarting.',
      inAllEyebrow: 'In every scope',
      inAll1: '6 months of implementation with the Thux team inside your company',
      inAll2: 'Weekly support · 4 sessions/month',
      inAll3: 'R.I.C.O. Diagnosis + Master Plan with the number agreed before',
      inAll4: 'Numbers dashboard updated weekly',
      guaranteeEyebrow: 'Guarantee',
      guaranteeBody: 'If in 6 months we don\'t reach at least 70% of the agreed number, we extend 60 days at no cost OR refund part of the investment. Your call.',
      guaranteeFootnote: 'The number for each scope is closed in the R.I.C.O. Diagnosis, signed by both sides, before we start.',
      ctaButton: 'I want to know which scope fits my company',
      ctaMicrocopy: 'The scope is defined together with you in the free diagnosis. No package sold blindly.',
    },
    cases: {
      eyebrow: 'Success cases',
      titlePart1: 'Results Thux delivered',
      titleAccent: 'to real clients.',
      description: 'The numbers below are literal — sales that grew, customers that stopped leaving, proven returns. Each company started with the diagnosis conversation.',
      case1Desc: 'Platform that organizes payment, content access and relationship with subscribers. Thux stepped in and fixed the customer path from start to finish.',
      case1Tag1: '−30% churn',
      case1Tag2: '+100% sales',
      case2Desc: 'Brings WhatsApp, Instagram and other channels into one place for small and medium businesses. Thux organized the sales path and the service.',
      case2Tag1: '+400% users',
      case2Tag2: '+100% sales',
      case3Desc: 'Automatic WhatsApp service that increases sales. Thux put AI to work directly on closing and follow-up.',
      case3Tag1: '−36% churn',
      case3Tag2: '+10% sales',
      case3Tag3: '5× ROI',
    },
    money: {
      eyebrow: 'The proof in numbers',
      titlePart1: 'How much money is leaking from your company',
      titleAccent: 'right now?',
      description: 'Four common leaks for those billing R$ 1M to R$ 15M. Plug in your business numbers. The calculator doesn\'t guess — it shows the math already happening in your company.',
      totalEyebrow: 'Sum of the 4 numbers',
      totalTitlePart1: 'The money leaking from your company,',
      totalTitleAccent: 'per year:',
      totalBody1: 'That\'s the size of the difference between working with Thux and staying as you are. It\'s not a promise.',
      totalBodyStrong: 'It\'s the math of your own business.',
      breakdown1: 'Lost sales',
      breakdown2: 'Lost profit',
      breakdown3: 'Customer who didn\'t return',
      breakdown4: 'Cost you can cut',
      ctaButton: 'I want my company\'s diagnosis',
      ctaMicrocopy: '60 minutes · free · no hard sell at the end',
      navStep: 'Step',
      navOf: 'of',
      navResult: 'Result · Total of the 4 leaks',
      navBack: 'Back',
      navContinue: 'Continue',
      navSeeTotal: 'See total',
    },
    calc1: {
      title: 'Lost sales',
      subtitle: 'New customer arrives and no one answers in time',
      tooltip: 'Studies show customers answered within 5 minutes buy up to 21x more than those answered after 30 minutes. This calculator shows the size of the sale your company misses when response is delayed.',
      f1: 'How many new customers come in per month',
      f1Suffix: 'per month',
      f2: '% answered in under 5 minutes',
      f3: 'How much each customer pays on average',
      f4: 'Out of 100 prospects, how many become clients today',
      f5: 'Out of 100 prospects, how many would become clients with fast response',
      monthly: 'Lost sales per month',
      yearly: 'Lost sales per year',
    },
    calc2: {
      title: 'Lost profit on sales',
      subtitle: 'Meeting that happened but didn\'t close',
      tooltip: 'Research shows 80% of sales need 5+ follow-ups, but nearly half of salespeople give up after the first contact. This calculator shows the profit lost when follow-up is poor.',
      f1: 'Quality meetings you have per month',
      f1Suffix: 'per month',
      f2: '% of meetings that turn into proposals',
      f3: '% of proposals that close today',
      f4: '% of proposals that would close with proper follow-up',
      f5: 'Average ticket per customer',
      monthly: 'Lost profit per month',
      yearly: 'Lost profit per year',
    },
    calc3: {
      title: 'Customer who didn\'t return',
      subtitle: 'Bought once and never came back',
      tooltip: 'Research shows that increasing repeat customers by 5% can grow profit 25–95%. This calculator shows the lost profit when you treat customers as one-time sales.',
      f1: 'Active customers in the last year',
      f1Suffix: 'customers',
      f2: '% who buy again within 12 months today',
      f3: '% who would return with proper relationship care',
      f4: 'Average ticket on repeat purchase',
      yearly: 'Lost profit per year',
    },
    calc4: {
      title: 'Cost you can cut',
      subtitle: 'Stacked tools and team time on repetitive tasks',
      tooltip: 'Research shows small and medium companies waste up to 30% of their software spend on overlapping or unused tools. And over 60% of back-office tasks can be done by AI.',
      f1: 'Monthly spend on commercial software (total)',
      f1Suffix: 'R$/month',
      f2: 'Hours per month team spends on repetitive tasks',
      f2Suffix: 'hours/month',
      f3: 'Average hourly cost of operational team',
      f3Suffix: 'R$/h',
      f4: '% of that you can cut with organization and AI',
      monthly: 'Optimizable cost per month',
      yearly: 'Optimizable cost per year',
    },
    outcome: {
      eyebrow: 'The outcome ahead',
      titlePart1: 'What changes in',
      titleAccent1: '90 days',
      titlePart2: ', in',
      titleAccent2: '6 months',
      titlePart3: ' and in',
      titleAccent3: '12 months',
      titlePart4: '.',
      h1Metric: '90 days',
      h1Title: 'Path mapped and 3 leaks closed.',
      h1Body: 'We design the complete customer path, show where it\'s stuck, and put 3 of those parts running with routine. You step out of operations and become the one tracking numbers. First results appear.',
      h2Metric: '6 months',
      h2Title: 'More predictable sales, profit back.',
      h2Body: 'The 6 stages of the path running with routine. New customer always answered, sales stabilized, customers buying more. Tools trimmed. Team doing what matters, not repetitive work.',
      h3Metric: '12 months',
      h3Title: 'The company works for you, not with you.',
      h3Body: 'You step out of operations day-to-day. Profit is back. Sales are now an engine — attract, close, serve and bring back spinning together. Company ready to grow more: hire right, open new markets, expand.',
      stat1: 'Fronts working together',
      stat2: 'Stages of the customer path',
      stat3: 'Years of applied experience',
    },
    testimonials: {
      bannerTitle: 'AI that works for your business while you focus on what matters',
      m1Value: '+87%',
      m1Label: 'in sales',
      m2Value: '−40%',
      m2Label: 'in cost',
      m3Value: '3×',
      m3Label: 'faster',
      m4Value: '+ Profit',
      m4Label: 'in cash flow',
      eyebrow: 'Real results',
      titlePart1: 'What happened after we got into',
      titleAccent: 'the operation.',
      description: 'Testimonials from those who decided to work with Thux to grow with organization — not by sheer effort.',
      featuredBadge: 'featured testimonial',
      role: {
        founder: 'Founder',
        ceo: 'CEO',
      },
      t1: 'Our product worked well, but the experience caused high churn. Thux applied its methodology and with the improvements, we reduced churn by 30% and increased conversion by 10%. The product became more professional.',
      t2: 'You were key to the project and part of our success comes from Thux\'s work. We grew 400% in clients and doubled the meetings that turn into sales.',
      t3: 'Before Thux, Tickpost had a functional but confusing interface, with weak visual identity and difficult navigation. They brought clarity for users, consistency and usability.',
      t4: 'Thux surprised us with attention, patience and delivery. They brought the support we needed to advance with quality.',
      t5: 'We are very happy with the result of our product validation page. Thank you so much for the partnership.',
    },
    howStarts: {
      eyebrow: 'How it starts',
      titlePart1: 'The first step is not a proposal.',
      titleAccent: 'It\'s a diagnosis.',
      description1: 'Before any work with Thux, we start with a',
      descriptionStrong: '60-minute conversation',
      description2: 'where the Thux team maps your company today: where money is leaking, the real size of what can be recovered, and the shortest path to start recovering. No proposal, no charge, no hard sell.',
      outputStrong: 'What you take from the conversation:',
      outputBody: 'a map of the customer path in your company, with 3 leak points and how much each one is worth, in dollars. From there, you decide.',
      step1Day: 'Today',
      step1Title: 'You fill out a quick form',
      step1Body: 'Five questions about revenue, sector, biggest problem and what you want to solve. 1 minute. That\'s what lets us arrive prepared.',
      step2Day: 'In 2 days',
      step2Title: 'Meeting scheduled on the calendar',
      step2Body: 'Within 48 hours you receive a calendar invite. 60 minutes with someone from Thux who understands your sector.',
      step3Day: 'In 5 days',
      step3Title: 'Diagnosis conversation',
      step3Body: 'We walk your customer path through the 6 stages. Show the 3 biggest leak points in your company. And calculate how much each one is worth, in dollars.',
      step4Day: 'In 7 days',
      step4Title: 'You receive the map in writing',
      step4Body: 'A document with your company\'s customer path today, the 3 leak points and how much each is worth. The map is yours, no matter what you decide later.',
      step5Day: 'In 10 days',
      step5Title: 'The decision',
      step5Body: 'If it makes sense for both sides, we present a path to work together. If not, you keep the diagnosis and move on. No charge, no hard feelings.',
      ctaButton: 'I want the diagnosis conversation',
      ctaWhats: 'Talk on WhatsApp',
    },
    faq: {
      eyebrow: 'FAQ',
      title: 'Any questions left?',
      description: 'Everything is clear even before our first conversation.',
      items: [
        { q: 'Is Thux a marketing agency?', a: 'No. We are a Business House. Agencies deliver leads, campaigns, and posts. We deliver revenue. Thux enters your commercial operation from end to end: from positioning and product, to lead generation, closing, and retention.' },
        { q: 'How much does it cost?', a: 'Thux\'s model has no standard fixed cost. We build the proposal after the free diagnosis because the investment is directly tied to the size of the bottleneck we will solve. If there is no clear projected return, we don\'t start the project.' },
        { q: 'What is this "free diagnosis"?', a: 'It\'s a 60-minute meeting where we apply the Prisma Method. You bring your numbers (revenue, margin, acquisition cost), and we map out exactly where money is leaking and how to stop it. No catch, the diagnosis document is yours even if we don\'t close a deal.' },
        { q: 'Will it work for my company?', a: 'Revenue Architecture works if your company has PMF (Product-Market Fit), already bills between R$ 1M and R$ 15M/year, and the owner feels the operation has become a bottleneck for growth. We have strong expertise in services, healthcare, education, technology, and industry.' },
        { q: 'How long until I see results?', a: 'Our initial setup timeframe is 60 to 90 days to organize the full funnel. However, in most cases, the diagnosis and the first few weeks of work already unlock money left on the table (e.g., rescuing lost leads, reactivating the base).' },
        { q: 'What if you don\'t hit the agreed number?', a: 'Clear guarantee: if in 6 months we don\'t reach at least 70% of what we agreed, we extend 60 days at no cost OR refund part of the investment. Your call. This is only possible because we surgically qualify who comes in.' },
      ],
    },
    decision: {
      eyebrow: 'The decision',
      titlePart1: 'Is your company going to start next year the same way as today, or',
      titleAccent: 'with Thux inside, organizing everything?',
      description: 'The numbers the calculator showed are not exceptions. They\'re the size of what leaks every year from companies that grew on grit, without organization. The math is in front of you. Now decide: start closing that tap in 90 days, or keep waiting for hard work to solve it.',
      ctaButton: 'I want the free diagnosis',
      ctaWhats: 'Talk on WhatsApp',
    },
    footer: {
      tagline: 'Business House',
      legalNotice: 'Thux · Business House · Prisma Method™ · Revenue AI · Full Funnel. Results shown are from real Thux clients. Each case depends on execution, market timing and the commitment of those inside the company.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use',
    },
    sticky: {
      cta: 'I want the free diagnosis · 60 min',
    },
    modal: {
      pill: 'Diagnosis · 60 minutes · free',
      title: 'Let\'s map your company.',
      description: 'Five questions. 1 minute. That\'s what lets us arrive prepared to truly help you.',
      fieldName: 'Full name',
      fieldNamePh: 'What can we call you?',
      fieldWhats: 'WhatsApp',
      fieldWhatsPh: '+1 555 555 5555',
      fieldEmail: 'Email',
      fieldEmailPh: 'you@email.com',
      fieldRevenue: 'Annual company revenue',
      revenueSelect: 'Select a range',
      revenue1: 'Less than R$ 1M',
      revenue2: 'R$ 1M to R$ 5M',
      revenue3: 'R$ 5M to R$ 15M',
      revenue4: 'More than R$ 15M',
      fieldGap: 'What is your biggest problem today?',
      gapSelect: 'Pick the main one',
      gap1: 'Attract more quality new customers',
      gap2: 'Close more sales',
      gap3: 'Make customers buy again',
      gap4: 'Cut operational cost',
      gap5: 'Step out of day-to-day operations',
      fieldDecisor: 'Are you the one who decides on hiring?',
      decisor1: 'I\'m the owner or partner',
      decisor2: 'I\'m a director and can decide',
      decisor3: 'I decide together with the partner',
      decisor4: 'I\'ll bring it to whoever decides',
      submit: 'Receive invite on WhatsApp',
      submitting: 'Sending…',
      microcopy: 'Your data stays only with Thux. No spam, no waitlist, no hard sell.',
      successTitlePart1: 'Got it.',
      successTitleAccent: 'Within 48 hours you\'ll receive an invite on your WhatsApp.',
      successBody1: 'Meanwhile, take a look at Instagram',
      successBody2: '— every day there\'s practical content for entrepreneurs to organize operations and earn more.',
      successCta: 'Go to Instagram',
      successClose: 'Close',
      errorRequired: 'Select an option',
      errorName: 'Enter your full name',
      errorWhats: 'Invalid WhatsApp',
      errorWhatsFormat: 'Use only numbers',
      errorEmail: 'Invalid email',
    },
  },

  es: {
    nav: {
      tagline: 'Casa de Negocios',
      howItWorks: 'Cómo funciona',
      product: 'El producto',
      calculator: 'Calculadora',
      howItStarts: 'Cómo empieza',
      cta: 'Diagnóstico',
      langLabel: 'Idioma',
    },
    hero: {
      eyebrow: 'arquitectura de ingresos · en operación',
      headline1: 'Tu empresa creció.',
      headline2: 'Tu operación no.',
      headline3: 'Y lo que está en riesgo',
      headline4: 'ahora es tu beneficio.',
      subheadPart1: 'Empresas entre',
      subheadAmount: 'R$ 1M y R$ 15M',
      subheadPart2: '? ',
      subheadBrand1: 'Thux',
      subheadPart3: ' entra, organiza todo de principio a fin con el ',
      subheadBrand2: 'Método Prisma™',
      subheadPart4: ' y pone ',
      subheadBrand3: 'inteligencia artificial',
      subheadPart5: ' donde marca la diferencia — para que ganes más, gastes menos y vuelvas a tener tiempo. En 60 días.',
      ctaPrimary: 'Descubrir cuánto está fugando',
      ctaSecondary: 'Ver cómo funciona',
      statBlocks: 'frentes',
      statBlocksValue: '4 áreas',
      statSteps: 'camino',
      statStepsValue: '6 etapas',
      statStatus: 'plazo',
      statStatusValue: '60 días',
    },
    heroTerminal: {
      cmd: '> diagnóstico de tu empresa',
      ok1: '✓ camino del cliente mapeado',
      ok2: '✓ puntos de fuga identificados',
      ok3: '✓ método listo para correr',
      step1: '01 · atraer',
      step2: '02 · calificar',
      step3: '03 · vender',
      step4: '04 · recibir bien',
      step5: '05 · entregar',
      step6: '06 · hacer volver',
      stepValue: 'R$ fugando',
      run: '... sumando tu dinero sobre la mesa',
      titleBar: 'diagnóstico · en vivo',
    },
    logosMarquee: {
      eyebrow: 'Empresas que trabajan con Thux',
      titleMuted: 'Más de 200 empresas atendidas.',
      title: 'Resultados comprobados en empresas reales.',
    },
    bigNumbers: {
      sectionEyebrow: 'Thux · Casa de Negocios',
      sectionTitle: 'La empresa que entra en tu operación y organiza todo para entregar resultados.',
      yearsLabel: 'Años entregando resultados',
      teamLabel: 'Profesionales en el equipo Thux',
      clientsLabel: 'Empresas atendidas',
      impactConvLabel: 'Más en ventas',
      impactConvSub: 'aumento promedio entre clientes',
      impactCostLabel: 'Menos en costos',
      impactCostSub: 'recorte en herramientas y tiempo de equipo',
      impactSpeedLabel: 'Más rápido para cerrar',
      impactSpeedSub: 'del primer contacto a la venta',
      impactGrowthLabel: 'Más crecimiento',
      impactGrowthSub: 'empresas que usan IA con método crecen el doble',
    },
    reality: {
      eyebrow: 'La realidad hoy',
      titleStrong: 'Llegaste hasta aquí a pulmón.',
      titleMuted: 'De aquí en adelante, el pulmón no basta. Lo que manda es organización.',
      blindSpotEyebrow: 'El punto ciego',
      blindSpotTitle: 'Creciste trabajando mucho. Pero llegaste al techo.',
      blindSpotBody: 'Doblaste de tamaño. Contrataste más gente. Compraste más herramientas. Pero el beneficio no creció igual. Sigues operando, el resultado se achica con cada nueva contratación, y el equipo no da abasto con lo que entra.',
      blindSpotBodyStrong: 'Trabajar más se volvió un techo, no una palanca.',
      blindSpotTagLabel: 'la verdad',
      blindSpotTagValue: 'SUDOR > ORGANIZACIÓN',
      profilesEyebrow: 'Quién pasa por esto',
      profilesTitle: 'Mismo dolor. Cuatro tipos de empresa.',
      profilesSub: 'La historia se repite en quien creció rápido y se trabó.',
      profileClinicTitle: 'Clínica que creció',
      profileClinicBody: 'Agenda llena, publicidad cara, paciente nuevo tarda en volver.',
      profileOfficeTitle: 'Despacho de servicios',
      profileOfficeBody: 'Entra el proyecto, el socio se vuelve cuello de botella, el valor por trabajo no sube.',
      profileIndustryTitle: 'Industria y distribución',
      profileIndustryBody: 'Vende a otras empresas, ciclo largo, el vendedor olvida hacer seguimiento y la oportunidad se pierde.',
      profileCommerceTitle: 'Comercio especializado',
      profileCommerceBody: 'El cliente llega por Instagram, la atención humana no escala, y la venta se escapa.',
      diagnosisEyebrow: 'Lo que falta',
      diagnosisTitle: 'Falta organización, no tecnología.',
      diagnosisBody1: 'No necesitas más herramientas, más sistemas, más agencias. Necesitas ',
      diagnosisBodyStrong: 'un camino organizado',
      diagnosisBody2: ' — donde cada etapa tenga dueño, número para acompañar y ritmo definido. Son las 6 etapas del Embudo Completo. Sin eso, cualquier dinero invertido en marketing, ventas o IA se va por el desagüe.',
      indicatorHeader1: 'Qué medir',
      indicatorHeader2: 'Cómo está hoy',
      indicator1Label: 'Tiempo para responder a un nuevo cliente',
      indicator1Value: 'más de 3 horas',
      indicator1Note: '(en promedio)',
      indicator2Label: 'De cada 100 interesados, cuántos se vuelven clientes',
      indicator2Value: '8 a 14',
      indicator3Label: 'Cuántos clientes vuelven a comprar en 12 meses',
      indicator3Value: 'menos del 30%',
      indicator4Label: 'Cuánto del facturamiento va a software',
      indicator4Value: '4% a 9%',
    },
    realityNow: {
      eyebrow: 'La realidad hoy',
      titlePart1: 'Llegaste hasta aquí a puro pulmón.',
      titlePart2: 'A partir de ahora, el pulmón no basta. Lo que manda es la organización.',
      card1Eyebrow: 'El punto ciego',
      card1Title: 'Creciste trabajando mucho. Pero tocaste techo.',
      card1Body1: 'Duplicaste tu tamaño. Contrataste más gente. Compraste más herramientas. Pero las ganancias no crecieron a la par. Sigues operando, el resultado es menor con cada nueva contratación y el equipo no da abasto. ',
      card1BodyStrong: 'Trabajar más se volvió un techo, no una palanca.',
      card1TruthEyebrow: 'la verdad',
      card1TruthValue: 'SUDOR > ORGANIZACIÓN',
      card2Eyebrow: 'Quiénes pasan por esto',
      card2Title: 'Mismo dolor. Cuatro tipos de empresas.',
      card2Body: 'La historia se repite en quienes crecieron rápido y se estancaron.',
      perfis: [
        { title: 'Clínica que creció', body: 'Agenda llena, anuncios caros, el paciente nuevo tarda en volver.' },
        { title: 'Firma de servicios', body: 'Entra un proyecto, el socio es el cuello de botella, el valor por trabajo no sube.' },
        { title: 'Industria y distribuidora', body: 'Ventas B2B, ciclos largos, los vendedores olvidan hacer seguimiento y las oportunidades desaparecen.' },
        { title: 'Comercio especializado', body: 'El cliente llega por Instagram, la atención humana no da abasto y la venta se escapa.' },
      ],
      card3Eyebrow: 'Qué falta',
      card3Title: 'Falta organización, no tecnología.',
      card3Body1: 'No necesitas más herramientas, sistemas o agencias. Necesitas ',
      card3BodyStrong: 'un camino organizado',
      card3Body2: ' — donde cada etapa del trabajo tiene un dueño, un número a seguir y un ritmo definido. Son las 6 etapas del Embudo Completo. Sin eso, cualquier dinero invertido en marketing, ventas o IA se va por el desagüe.',
      metricsEyebrow1: 'Qué medir',
      metricsEyebrow2: 'Cómo está hoy',
      indicadores: [
        { label: 'Tiempo para responder a un nuevo cliente', value: 'más de 3 hrs', highlight: '(promedio)' },
        { label: 'De 100 interesados, cuántos se vuelven clientes', value: '8 a 14' },
        { label: 'Cuántos clientes vuelven a comprar en 12 meses', value: 'menos de 30%' },
        { label: 'Qué porcentaje de ingresos va a herramientas de software', value: '4% a 9%' },
      ],
      closingBridge: 'En los 4 casos, el problema no es el equipo. Es el camino. Y el camino lo diseñamos. No improvisamos.',
      enemy: {
        eyebrow: 'El verdadero enemigo',
        title: 'No tienes un problema de herramienta.',
        body: 'Tienes demasiadas herramientas que no se hablan entre sí, agencias que se contradicen y una planilla que nadie actualiza. Revenue AI no es otro sistema en la pila. Es lo que hace que todo finalmente funcione junto. O salga.',
      },
    },
    gap: {
      eyebrow: 'La brecha',
      titlePart1: 'Entre crecer y tener beneficio existe una',
      titleAccent: 'capa entera',
      titlePart2: 'que nadie está construyendo.',
      body: 'No es tu culpa. El empresario aprendió a operar, vender, contratar y llevar el día a día. Pero nadie enseñó a diseñar la estructura que hace que todo eso funcione junto — y eso es exactamente lo que falta ahora.',
      cmpAgencyLabel: 'Agencia de marketing',
      cmpAgencyDelivers: 'trae más clientes nuevos.',
      cmpSoftwareLabel: 'Empresa de software',
      cmpSoftwareDelivers: 'entrega la herramienta.',
      cmpConsultLabel: 'Consultoría',
      cmpConsultDelivers: 'entrega informe con recomendaciones.',
      cmpThuxLabel: 'Thux',
      cmpThuxDelivers: 'entra en tu empresa y organiza todo para entregar resultados.',
    },
    intervention: {
      eyebrow: 'La solución',
      titleStrong: 'Thux no es una empresa de software.',
      titleMutedPart1: 'Es una',
      titleMutedBrand: 'Casa de Negocios',
      titleMutedPart2: '— entra en tu empresa, organiza todo de principio a fin y el resultado aparece en tu caja.',
      description: 'Seis razones para confiar en el trabajo. Cada una es experiencia práctica, no promesa de marketing. El Método Prisma™ y Revenue AI nacieron funcionando en empresas reales — primero en Thux, luego en clientes — antes de volverse oferta.',
      blocksEyebrow: 'Los 4 frentes del trabajo',
      blocksTitle: 'De lo desordenado a lo predecible.',
      block1Title: 'POSICIONAMIENTO',
      block1Sub: 'a quién le hablas',
      block2Title: 'PRODUCTO',
      block2Sub: 'precio y oferta',
      block3Title: 'CLIENTE NUEVO',
      block3Sub: 'camino predecible',
      block4Title: 'CIERRE',
      block4Sub: 'venta sin descuento',
      bowtieEyebrow: 'Embudo Completo · 6 etapas',
      bowtieTitle: 'El camino entero, no solo la venta.',
      bowtieAttract: 'Cliente nuevo',
      bowtieRetain: 'Retención',
      bowtieDeal: 'cerró negocio',
      bowtieStep1: 'Atraer cliente nuevo',
      bowtieStep2: 'Saber si te sirve',
      bowtieStep3: 'Vender',
      bowtieStep3Hl: 'la venta cierra aquí',
      bowtieStep4: 'Recibir bien',
      bowtieStep5: 'Entregar con calidad',
      bowtieStep6: 'Hacer que vuelva a comprar',
      bowtieFooterPart1: 'La mayoría de empresas tiene solo',
      bowtieFooterStrong1: '2 etapas organizadas',
      bowtieFooterPart2: '(atraer y vender) y',
      bowtieFooterStrong2: '4 etapas a la improvisación',
      bowtieFooterPart3: '. El Embudo Completo organiza las 6 con rutina, números para seguir e IA — donde tenga sentido, en la medida que tenga sentido.',
      ecosystemEyebrow: 'Cómo todo se conecta',
      ecosystemTitle: 'Vender más no es suerte. Es un sistema bien armado.',
      ecosystemTop1: 'NÚMEROS',
      ecosystemTop2: 'RUTINA',
      ecosystemTop3: 'EVALUACIÓN',
      ecosystemMid1: 'OPERACIÓN',
      ecosystemMid2: 'CALIDAD',
      ecosystemMid3: 'CRECIMIENTO',
      ecosystemCoreTitle: 'Revenue Architecture',
      ecosystemCore1: 'posiciona',
      ecosystemCore2: 'oferta',
      ecosystemCore3: 'cliente nuevo',
      ecosystemCore4: 'cierra',
      pillarsEyebrow: 'Por qué Thux',
      pillarsTitleStrong: 'Seis razones para confiar.',
      pillarsTitleMuted: 'Cada una es experiencia práctica, no promesa de marketing.',
      pillar1Title: 'Casa de Negocios. No empresa de software.',
      pillar1Body: 'Thux no vende herramienta. Thux entra en tu empresa, organiza el trabajo de principio a fin y el resultado aparece directo en tu beneficio. El software es medio. El fin es dinero en caja.',
      pillar2Title: 'Método Prisma™ — encuentra dinero que estaba escondido.',
      pillar2Body: 'Toda empresa tiene dinero fugando sin notarlo. Prisma es el método de Thux que mira tu empresa por cuatro lados, encuentra esas fugas y transforma cada una en una acción con plazo, dueño y número.',
      pillar2Quote: 'Prisma es lo que permite a Thux entrar en cualquier empresa y, en 60 días, mostrar tres oportunidades de ingresos que nadie estaba viendo.',
      pillar3Title: 'Revenue AI · inteligencia artificial con objetivo claro.',
      pillar3Body: 'La IA no es adorno. No es "pongamos un bot a responder". Es inteligencia artificial aplicada en el punto exacto donde devuelve velocidad, consistencia y más ventas — con número acordado antes y panel siguiendo después.',
      pillar4Title: 'Equipo dedicado · más de 30 profesionales.',
      pillar4Body: 'Equipo completo — gente de producto, datos, automatización, copy y operaciones — trabajando como si fuera tu propio equipo. Sin freelancer desapareciendo, sin agencia empujando entregables. Operación enchufada en tu negocio real.',
      pillar5Title: 'Más de 200 empresas atendidas. Más de 5 años en el campo.',
      pillar5Body: 'Clientes en salud, educación, servicios, industria y tecnología. Casos con números reales — venta recuperada, cliente que dejó de salir, costo recortado. Autoridad construida en resultado de cliente. No en posts de Instagram.',
      pillar6Title: 'Resultado acordado, o no empieza.',
      pillar6Body: 'El número se define antes del trabajo. Panel cada semana, reunión de seguimiento, plazo de 60 días. Si Thux entra y no mueve el número acordado, es porque el número estaba mal o la empresa no estaba lista — y eso se vuelve diagnóstico, no factura.',
    },
    prisma: {
      eyebrow: 'Método Prisma™ · 4 lados',
      title: 'Encuentra el dinero escondido. Lo convierte en ingresos que vuelven cada mes.',
      description: 'Prisma es el método propio de Thux. Funciona como un cristal: la misma empresa, mirada por cuatro lados distintos, muestra oportunidades que estaban ahí adelante — pero nadie veía.',
      face1: 'MUESTRA',
      tab1: 'Diagnóstico',
      face1Title: 'Mira todo. Encuentra dónde está fugando dinero.',
      face1Body: 'Thux mapea todo el camino de tu cliente — desde que descubre tu empresa hasta que vuelve a comprar. Y muestra, en pesos, dónde está fugando venta, beneficio y tiempo. Sin adivinar.',
      face2: 'ELIGE',
      tab2: 'Prioridad',
      face2Title: 'Separa lo que devuelve dinero ahora de lo que es proyecto eterno.',
      face2Body: 'No se puede arreglar todo a la vez. Solo ponemos en la fila lo que vuelve como ingreso en 60 días. El resto queda para después. Sin promesas de largo plazo, solo lo que hace andar la empresa ahora.',
      face3: 'INSTALA',
      tab3: 'Instalación',
      face3Title: 'Pone la inteligencia artificial a trabajar en los puntos correctos.',
      face3Body: 'La IA entra donde devuelve resultado: respondiendo cliente nuevo al instante, organizando atención, recordando hacer seguimiento, ayudando al cliente a volver. No es tecnología por moda. Es tecnología que sube la caja.',
      face4: 'ACOMPAÑA',
      tab4: 'Resultado',
      face4Title: 'Acuerda el número antes. Acompaña cada semana.',
      face4Body: 'Cada trabajo empieza con un número claro: cuánto va a subir en venta, cuánto va a bajar en costos. Panel actualizado cada día, reunión cada semana. Sin sorpresa. Sin "depende".',
      illTagLost: 'Venta perdida',
      illTagChurn: 'Cliente que se va',
      illTagProfit: 'Beneficio escondido',
      illTagCost: 'Costo optimizable',
    },
    product: {
      eyebrow: 'El producto · Revenue AI',
      title: 'Máquina de Ingresos Predecibles Inteligente.',
      titleAccent: 'En 3 escopes.',
      description: 'No necesitas empezar por todo. Thux instala la cantidad de embudo que tiene sentido para tu empresa hoy, y la expande conforme creces. Misma metodología, mismo equipo, mismo acompañamiento semanal. Lo que cambia es cuánto de tu operación Thux organiza.',
      funnelEyebrow: 'El Embudo Completo · 6 etapas',
      funnelTitle: 'El camino entero del cliente.',
      funnelHelper: 'Haz clic en cada escopo abajo para ver lo que cubre.',
      bowtie: {
        s1: 'Atraer',
        s2: 'Calificar',
        s3: 'Vender',
        s4: 'Recibir',
        s5: 'Entregar',
        s6: 'Hacer volver',
        deal: 'Cerró negocio',
        attractEyebrow: 'Cliente nuevo',
        retainEyebrow: 'Retención',
      },
      scopesEyebrow: 'Los 3 escopes',
      scopesTitle: 'Empieza con el escopo que tiene sentido hoy.',
      premiumLabel: 'Premium',
      premiumPositioning: 'Embudo entero volviéndose motor',
      premiumFor: 'Para quien vende y entrega bien, pero el dueño sigue ahogado en el día a día en vez de comandar la empresa.',
      premiumCovers: 'Embudo completo · etapas 1 a 6',
      premiumOutcome: 'Cliente vuelve a comprar solo, recomienda solo, y la operación se vuelve motor de ingresos predecibles.',
      avancadoLabel: 'Avanzado',
      avancadoPositioning: 'Camino del medio organizado',
      avancadoFor: 'Para quien cierra venta, pero pierde al cliente después. Socio sigue siendo cuello de botella del medio: aguantando entrega, calidad y recompra.',
      avancadoCovers: 'Topo + medio · etapas 1 a 5',
      avancadoOutcome: 'Cliente nuevo entra, es recibido, empieza a usar y percibe valor sin el socio encima. Satisfacción subiendo, cliente quedándose.',
      essencialLabel: 'Esencial',
      essencialPositioning: 'Topo del embudo organizado',
      essencialFor: 'Para quien pierde cliente nuevo en la puerta de entrada. Contacto llega, tarda en ser respondido y se evapora antes de volverse venta.',
      essencialCovers: 'Topo · etapas 1 a 3',
      essencialOutcome: 'Cliente nuevo respondido en 3 minutos, filtrado por IA, agendado directo en la agenda. El socio deja de hacer atención de primera línea.',
      upgradeBridge: 'Empiezas con el escopo que tiene sentido hoy. Cuando la operación responda, expandimos sin reiniciar.',
      inAllEyebrow: 'En todos los escopes',
      inAll1: '6 meses de implementación con el equipo Thux dentro de tu empresa',
      inAll2: 'Acompañamiento semanal · 4 sesiones/mes',
      inAll3: 'Diagnóstico R.I.C.O. + Plan Maestro con número acordado antes',
      inAll4: 'Panel de números actualizado cada semana',
      guaranteeEyebrow: 'Garantía',
      guaranteeBody: 'Si en 6 meses no alcanzamos al menos el 70% del número acordado, extendemos 60 días sin costo O devolvemos parte de la inversión. Tu decisión.',
      guaranteeFootnote: 'El número de cada escopo se cierra en el Diagnóstico R.I.C.O., firmado por ambos lados, antes de empezar.',
      ctaButton: 'Quiero saber qué escopo encaja en mi empresa',
      ctaMicrocopy: 'El escopo se define contigo en el diagnóstico gratuito. Sin paquete vendido a ciegas.',
    },
    cases: {
      eyebrow: 'Casos de éxito',
      titlePart1: 'Resultados que Thux entregó',
      titleAccent: 'a clientes reales.',
      description: 'Los números abajo son literales — venta que creció, cliente que dejó de salir, retorno comprobado. Cada empresa empezó con la conversación de diagnóstico.',
      case1Desc: 'Plataforma que organiza pago, acceso a contenido y relación con suscriptores. Thux entró y arregló el camino del cliente de principio a fin.',
      case1Tag1: '−30% de cliente saliendo',
      case1Tag2: '+100% en ventas',
      case2Desc: 'Junta WhatsApp, Instagram y otros canales en un solo lugar para empresas pequeñas y medianas. Thux organizó el camino de la venta y la atención.',
      case2Tag1: '+400% en clientes',
      case2Tag2: '+100% en ventas',
      case3Desc: 'Atención automática en WhatsApp que aumenta la venta. Thux puso inteligencia artificial a trabajar directo en el cierre y el seguimiento.',
      case3Tag1: '−36% de cliente saliendo',
      case3Tag2: '+10% en ventas',
      case3Tag3: '5× más retorno',
    },
    money: {
      eyebrow: 'La prueba en números',
      titlePart1: 'Cuánto dinero está fugando de tu empresa',
      titleAccent: 'ahora?',
      description: 'Cuatro fugas comunes en quienes facturan entre R$ 1M y R$ 15M. Pon los números de tu negocio. La calculadora no adivina — muestra la cuenta que ya está pasando en tu empresa.',
      totalEyebrow: 'Suma de las 4 cuentas',
      totalTitlePart1: 'El dinero que está fugando de tu empresa,',
      totalTitleAccent: 'por año:',
      totalBody1: 'Ese es el tamaño de la diferencia entre trabajar con Thux y seguir como hoy. No es promesa.',
      totalBodyStrong: 'Es la cuenta de tu propio negocio.',
      breakdown1: 'Venta perdida',
      breakdown2: 'Beneficio perdido',
      breakdown3: 'Cliente que no volvió',
      breakdown4: 'Gasto que se puede recortar',
      ctaButton: 'Quiero el diagnóstico de mi empresa',
      ctaMicrocopy: '60 minutos · gratis · sin venta forzada al final',
      navStep: 'Paso',
      navOf: 'de',
      navResult: 'Resultado · Total de las 4 fugas',
      navBack: 'Volver',
      navContinue: 'Continuar',
      navSeeTotal: 'Ver el total',
    },
    calc1: {
      title: 'Venta perdida',
      subtitle: 'Cliente nuevo que llega y nadie atiende a tiempo',
      tooltip: 'Estudios muestran que clientes atendidos en hasta 5 minutos compran hasta 21x más que los atendidos después de 30 minutos. Esta calculadora muestra el tamaño de la venta que tu empresa deja de hacer cuando la respuesta tarda.',
      f1: 'Cuántos clientes nuevos entran por mes',
      f1Suffix: 'por mes',
      f2: '% atendido en hasta 5 minutos',
      f3: 'Cuánto paga cada cliente en promedio',
      f4: 'De cada 100 interesados, cuántos se vuelven clientes hoy',
      f5: 'De cada 100 interesados, cuántos se volverían clientes con respuesta rápida',
      monthly: 'Venta perdida por mes',
      yearly: 'Venta perdida por año',
    },
    calc2: {
      title: 'Beneficio perdido en ventas',
      subtitle: 'Reunión que pasó pero no cerró',
      tooltip: 'Investigaciones muestran que el 80% de las ventas necesitan 5+ seguimientos, pero casi la mitad de los vendedores se rinde después del primer contacto. Esta calculadora muestra el beneficio perdido cuando el seguimiento es pobre.',
      f1: 'Cuántas reuniones buenas haces por mes',
      f1Suffix: 'por mes',
      f2: '% de reuniones que se vuelven propuesta',
      f3: '% de propuestas que cierran hoy',
      f4: '% de propuestas que cerrarían con buen seguimiento',
      f5: 'Ticket promedio por cliente',
      monthly: 'Beneficio perdido por mes',
      yearly: 'Beneficio perdido por año',
    },
    calc3: {
      title: 'Cliente que no volvió',
      subtitle: 'Compró una vez y nunca más apareció',
      tooltip: 'Investigaciones muestran que aumentar 5% los clientes que vuelven puede subir el beneficio entre 25% y 95%. Esta calculadora muestra el beneficio perdido cuando tratas al cliente como venta única.',
      f1: 'Clientes activos en el último año',
      f1Suffix: 'clientes',
      f2: '% que vuelve a comprar en 12 meses hoy',
      f3: '% que volvería con buen cuidado del relacionamiento',
      f4: 'Ticket promedio en recompra',
      yearly: 'Beneficio perdido por año',
    },
    calc4: {
      title: 'Gasto que se puede recortar',
      subtitle: 'Herramientas apiladas y tiempo del equipo en tareas repetitivas',
      tooltip: 'Investigaciones muestran que pequeñas y medianas empresas tiran hasta 30% del gasto en software por herramientas que hacen lo mismo o que nadie usa. Y más del 60% de tareas de oficina pueden hacerse con IA.',
      f1: 'Cuánto gastas por mes en software (todo)',
      f1Suffix: 'R$/mes',
      f2: 'Cuántas horas el equipo gasta por mes en tareas repetitivas',
      f2Suffix: 'horas/mes',
      f3: 'Cuánto cuesta una hora de tu equipo',
      f3Suffix: 'R$/h',
      f4: '% de eso que se puede recortar con organización e IA',
      monthly: 'Costo optimizable por mes',
      yearly: 'Costo optimizable por año',
    },
    outcome: {
      eyebrow: 'El resultado por delante',
      titlePart1: 'Lo que cambia en',
      titleAccent1: '90 días',
      titlePart2: ', en',
      titleAccent2: '6 meses',
      titlePart3: ' y en',
      titleAccent3: '12 meses',
      titlePart4: '.',
      h1Metric: '90 días',
      h1Title: 'Camino mapeado y 3 fugas resueltas.',
      h1Body: 'Diseñamos el camino completo de tu cliente, mostramos dónde se traba, y ponemos 3 partes funcionando con rutina. Sales de la operación y pasas a acompañar números. Aparecen los primeros resultados.',
      h2Metric: '6 meses',
      h2Title: 'Venta más predecible, beneficio de vuelta.',
      h2Body: 'Las 6 etapas del camino funcionando con rutina. Cliente nuevo siempre respondido, venta estabilizada, cliente volviendo a comprar más. Herramientas recortadas. Equipo haciendo lo que importa, no tarea repetitiva.',
      h3Metric: '12 meses',
      h3Title: 'La empresa trabaja por ti, no contigo.',
      h3Body: 'Sales del día a día operativo. El beneficio volvió. La venta ahora es un engranaje — atraer, cerrar, atender y hacer volver girando juntos. Empresa lista para crecer más: contratar gente correcta, abrir mercado nuevo, expandir.',
      stat1: 'Frentes de trabajo juntos',
      stat2: 'Etapas del camino del cliente',
      stat3: 'Años de experiencia aplicada',
    },
    testimonials: {
      bannerTitle: 'IA que trabaja por tu negocio mientras te ocupas de lo que importa',
      m1Value: '+87%',
      m1Label: 'en ventas',
      m2Value: '−40%',
      m2Label: 'en costo',
      m3Value: '3×',
      m3Label: 'más rápido',
      m4Value: '+ Beneficio',
      m4Label: 'en caja',
      eyebrow: 'Resultados reales',
      titlePart1: 'Lo que pasó después de que entramos',
      titleAccent: 'en la operación.',
      description: 'Testimonios de quienes decidieron trabajar con Thux para crecer con organización — no a pulmón.',
      featuredBadge: 'testimonio destacado',
      role: {
        founder: 'Fundador',
        ceo: 'CEO',
      },
      t1: 'Nuestro producto funcionaba bien, pero la experiencia generaba alto churn. Thux aplicó su metodología y con las mejoras, redujimos el churn en 30% y aumentamos la conversión en 10%. El producto quedó más profesional.',
      t2: 'Ustedes fueron clave en el proyecto y parte de nuestro éxito viene del trabajo de Thux. Crecimos 400% en clientes y duplicamos las reuniones que se vuelven venta.',
      t3: 'Antes de Thux, Tickpost tenía una interfaz funcional pero confusa, con identidad visual débil y navegación difícil. Trajeron claridad para los usuarios, consistencia y usabilidad.',
      t4: 'Thux nos sorprendió con atención, paciencia y entrega. Trajeron el apoyo que necesitábamos para avanzar con calidad.',
      t5: 'Estamos muy contentos con el resultado de nuestra página de validación de producto. Muchas gracias por la alianza.',
    },
    howStarts: {
      eyebrow: 'Cómo empieza',
      titlePart1: 'La primera etapa no es propuesta.',
      titleAccent: 'Es diagnóstico.',
      description1: 'Antes de cualquier trabajo con Thux, empezamos con una',
      descriptionStrong: 'conversación de 60 minutos',
      description2: 'donde el equipo Thux mapea tu empresa hoy: dónde está fugando dinero, el tamaño real de lo que se puede recuperar, y el camino más corto para empezar a recuperar. Sin propuesta, sin cobro, sin venta forzada.',
      outputStrong: 'Lo que te llevas de la conversación:',
      outputBody: 'un mapa del camino del cliente en tu empresa, con 3 puntos donde está fugando dinero y cuánto vale cada uno, en pesos. De ahí en adelante, tú decides.',
      step1Day: 'Hoy',
      step1Title: 'Llenas un formulario rápido',
      step1Body: 'Cinco preguntas sobre el facturamiento, el sector, el mayor problema hoy y qué quieres resolver. 1 minuto. Eso permite que lleguemos preparados.',
      step2Day: 'En 2 días',
      step2Title: 'Reunión agendada en el calendario',
      step2Body: 'En hasta 48 horas recibes una invitación con el link de la reunión. 60 minutos con alguien de Thux que entiende tu sector.',
      step3Day: 'En 5 días',
      step3Title: 'Conversación de diagnóstico',
      step3Body: 'Pasamos el camino de tu cliente por las 6 etapas. Mostramos los 3 mayores puntos donde tu empresa fuga dinero. Y calculamos cuánto vale cada uno, en pesos.',
      step4Day: 'En 7 días',
      step4Title: 'Recibes el mapa por escrito',
      step4Body: 'Un documento con el camino del cliente de tu empresa hoy, los 3 puntos de fuga y cuánto vale cada uno. El mapa es tuyo, sin importar lo que decidas después.',
      step5Day: 'En 10 días',
      step5Title: 'La decisión',
      step5Body: 'Si tiene sentido para ambos lados, presentamos un camino para trabajar juntos. Si no, te quedas con el diagnóstico y sigues. Sin cobro, sin resentimiento.',
      ctaButton: 'Quiero la conversación de diagnóstico',
      ctaWhats: 'Hablar por WhatsApp',
    },
    faq: {
      eyebrow: 'Preguntas Frecuentes',
      title: '¿Quedó alguna duda?',
      description: 'Todo claro incluso antes de nuestra primera conversación.',
      items: [
        { q: '¿Thux es una agencia de marketing?', a: 'No. Somos una Casa de Negocios. Las agencias entregan leads, campañas y publicaciones. Nosotros entregamos ingresos. Thux entra en su operación comercial de principio a fin: desde el posicionamiento y producto, hasta la captación, cierre y retención.' },
        { q: '¿Cuánto cuesta el trabajo?', a: 'El modelo de Thux no tiene un costo fijo estándar. Construimos la propuesta después del diagnóstico gratuito, porque la inversión está directamente vinculada al tamaño del cuello de botella que vamos a resolver. Si no hay un retorno proyectado claro, no iniciamos el proyecto.' },
        { q: '¿Qué es este "diagnóstico gratuito"?', a: 'Es una reunión de 60 minutos donde aplicamos el Método Prisma. Usted trae sus números (facturación, margen, costo de adquisición) y nosotros mapeamos dónde se está filtrando el dinero y cómo detenerlo. Sin trampas, el documento de diagnóstico es suyo incluso si no cerramos el trato.' },
        { q: '¿Funciona para mi empresa?', a: 'La Revenue Architecture funciona si su empresa tiene PMF (Product-Market Fit), ya factura entre R$ 1M y R$ 15M/año y el dueño siente que la operación se ha convertido en un cuello de botella para el crecimiento. Tenemos fuerte presencia en servicios, salud, educación, tecnología e industria.' },
        { q: '¿En cuánto tiempo veo resultados?', a: 'Nuestro plazo de configuración inicial es de 60 a 90 días para organizar el embudo completo. Sin embargo, en la mayoría de los casos, el diagnóstico y las primeras semanas de trabajo ya liberan dinero que estaba sobre la mesa (ej.: rescate de leads perdidos, reactivación de base).' },
        { q: '¿Y si no alcanzan el número acordado?', a: 'Garantía clara: si en 6 meses no alcanzamos al menos el 70% de lo que acordamos, extendemos 60 días sin costo O devolvemos parte de la inversión. Tu decisión. Esto solo es posible porque calificamos quirúrgicamente quién entra.' },
      ],
    },
    decision: {
      eyebrow: 'La decisión',
      titlePart1: 'Tu empresa va a empezar el próximo año igual que hoy, o',
      titleAccent: '¿con Thux dentro, organizando todo?',
      description: 'Los números que mostró la calculadora no son excepciones. Es el tamaño de lo que fuga cada año en empresas que crecieron a pulmón, sin organización. La cuenta apareció frente a ti. Ahora decide: empezar a cerrar esa canilla en 90 días, o seguir esperando que trabajar más lo resuelva.',
      ctaButton: 'Quiero el diagnóstico gratuito',
      ctaWhats: 'Hablar por WhatsApp',
    },
    footer: {
      tagline: 'Casa de Negocios',
      legalNotice: 'Thux · Casa de Negocios · Método Prisma™ · Revenue AI · Embudo Completo. Los resultados mostrados son de clientes reales de Thux. Cada caso depende de la ejecución, el momento del mercado y el compromiso de quienes están dentro de la empresa.',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Uso',
    },
    sticky: {
      cta: 'Quiero el diagnóstico gratuito · 60 min',
    },
    modal: {
      pill: 'Diagnóstico · 60 minutos · gratis',
      title: 'Vamos a mapear tu empresa.',
      description: 'Cinco preguntas. 1 minuto. Eso permite que lleguemos preparados para ayudarte de verdad.',
      fieldName: 'Nombre completo',
      fieldNamePh: '¿Cómo te podemos llamar?',
      fieldWhats: 'WhatsApp',
      fieldWhatsPh: '+54 11 1234-5678',
      fieldEmail: 'Email',
      fieldEmailPh: 'tu@email.com',
      fieldRevenue: 'Facturamiento anual de la empresa',
      revenueSelect: 'Selecciona un rango',
      revenue1: 'Menos de R$ 1M',
      revenue2: 'R$ 1M a R$ 5M',
      revenue3: 'R$ 5M a R$ 15M',
      revenue4: 'Más de R$ 15M',
      fieldGap: '¿Cuál es tu mayor problema hoy?',
      gapSelect: 'Elige el principal',
      gap1: 'Atraer más clientes nuevos de calidad',
      gap2: 'Cerrar más ventas',
      gap3: 'Hacer que el cliente vuelva a comprar',
      gap4: 'Recortar costo operativo',
      gap5: 'Salir del día a día de la empresa',
      fieldDecisor: '¿Eres quien decide la contratación?',
      decisor1: 'Soy el dueño o socio',
      decisor2: 'Soy director y puedo decidir',
      decisor3: 'Decido junto al socio',
      decisor4: 'Lo voy a llevar a quien decide',
      submit: 'Recibir invitación por WhatsApp',
      submitting: 'Enviando…',
      microcopy: 'Tus datos quedan solo con Thux. Sin spam, sin lista de espera, sin venta forzada.',
      successTitlePart1: 'Recibido.',
      successTitleAccent: 'En hasta 48 horas recibes invitación en tu WhatsApp.',
      successBody1: 'Mientras tanto, mira el Instagram',
      successBody2: '— todos los días hay contenido práctico para empresarios organizar la operación y ganar más.',
      successCta: 'Ir al Instagram',
      successClose: 'Cerrar',
      errorRequired: 'Selecciona una opción',
      errorName: 'Ingresa tu nombre completo',
      errorWhats: 'WhatsApp inválido',
      errorWhatsFormat: 'Usa solo números',
      errorEmail: 'Email inválido',
    },
  },
};
/* eslint-enable max-len */

export type Translation = (typeof dictionary)['pt'];
